export function convertToGrams(amount, unit, slug, foodInfo) {
    if (!amount || !unit) return null;
    const density = foodInfo[slug]?.density;
    if (!density) return null;
  
    if (unit === "l" || unit === "liter") return amount * density.dl * 10;
    if (unit === "dl") return amount * density.dl;
    if (unit === "msk") return amount * density.msk;
    if (unit === "tsk") return amount * density.tsk;
    if (unit === "krm") return amount * (density.tsk / 5);
    if (unit === "g" || unit === "gram") return amount;
    if (unit === "kg") return amount * 1000;
    if (unit === "hg") return amount * 100;
  
    return null;
  }
  